import { render, staticRenderFns } from "./WalletSummaryCard.vue?vue&type=template&id=0f0dbb13&"
import script from "./WalletSummaryCard.vue?vue&type=script&lang=js&"
export * from "./WalletSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports